var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegoBrick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#10A2D9;}\n\t.st1{fill:#1E2327;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-13.6-326.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.3,25.8V17c0-1.5-1.2-2.7-2.7-2.7H61.8c-1.5,0-2.7,1.2-2.7,2.7v8.8H40.4V17c0-1.5-1.2-2.7-2.7-2.7H11.8 c-1.5,0-2.7,1.2-2.7,2.7v8.8H0v60h100v-60H90.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegoBrick);
export default __webpack_public_path__ + "static/media/lego-brick.eb531df6dec2a6f76633def73da693e1.svg";
export { ForwardRef as ReactComponent };